@if (sensorData(); as sensorData) {
  <div class="sensor py-2" [class.has-deviation]="sensorData.sensor1.hasDeviation">
    <div>{{ sensorData.sensor1.label }}</div>
    <div>{{ sensorData.sensor1.value | number: '1.0-0' }}</div>
  </div>
  <div class="sensor py-2" [class.has-deviation]="sensorData.sensor2.hasDeviation">
    <div>{{ sensorData.sensor2.label }}</div>
    <div>{{ sensorData.sensor2.value | number: '1.0-0' }}</div>
  </div>
  <div class="sensor py-2" [class.has-deviation]="sensorData.sensor3.hasDeviation">
    <div>{{ sensorData.sensor3.label }}</div>
    <div>{{ sensorData.sensor3.value | number: '1.0-0' }}</div>
  </div>
}
